import { render, staticRenderFns } from "./HalfContent.vue?vue&type=template&id=0c8a1085&"
import script from "./HalfContent.vue?vue&type=script&lang=js&"
export * from "./HalfContent.vue?vue&type=script&lang=js&"
import style0 from "./HalfContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports